import {useI18n} from "vue-i18n";

export default{
    name: "Modal",
    data(){
        return{
            isOpen: false,
            title: '',
            description: '',
            textCta: '',
            linkCta: '',
            pathImage: '',
            voted: false,
            flag: false
        }
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    mounted() {
        /**
         * Listen toggle-modal event
         */
        this.emitter.on("toggle-modal", object => {
            this.isOpen = object.isOpen;
            this.title = object.title;
            this.pathImage = object.pathImage;
            this.voted = object.voted;
            this.description = object.description;
            this.flag = object.flag;

            document.body.classList.add('no-scroll');
        });
    },
    methods: {
        closeModal(){
            this.emitter.emit("toggle-modal", false);
            document.body.classList.remove('no-scroll');
        }
    }
}
